module.exports = __webpack_public_path__ + "static/media/扩展转接模块.5abe42bc.png";